<template lang="pug">
doctype html
.footer
  .index_footer
    ul.van-clearfix
      router-link(to="/maternal/home" tag="li")
        img(src="/static/images/common/icon-footer-home-select.png" v-if="currentIndex == 0")
        img(src="/static/images/common/icon-footer-home.png" v-else)
        p 首页
      router-link( to="/maternal/mine" tag="li")
        img(src="/static/images/common/icon-footer-mine-select.png" v-if="currentIndex == 1")
        img(src="/static/images/common/icon-footer-mine.png" v-else)
        p 个人中心
</template>
<script type="text/ecmascript-6">
export default {
  inject: ['reload'],
  data() {
    return {};
  },
  props: {
    currentIndex: {
      type: Number
    }
  },
  created() {},
  watch: {},
  computed: {},
  methods: {},
  mounted() {},
  destroyed() {}
};
</script>
<style lang="less" scoped>
.index_footer {
  position: fixed;
  width: 100%;
  background-color: #ffffff;
  box-shadow:0 -1px 40px 0 rgba(204,204,204,0.4);
  z-index: 99;
  padding: 0;
  overflow: hidden;
	height: 100px;
  ul {
    width: 100%;
    padding:0 0 4px;
    display:flex;
    li {
      text-align: center;
      flex:1;
      img{
        width: 60px;
        height: 60px;
        vertical-align: top;
        margin-top: 4px;
      }
      i {
        background-size: cover;
        background-position: 50% 50%;
        background-repeat: no-repeat;
        background-size: 60px 60px;
        width: 60px;
        height: 60px;
        display: inline-block;
        vertical-align: top;
        margin-top: 4px;
        &.icon-home {
          background-image: url(/static/images/common/icon-footer-home.png);
        }
        &.icon-mine {
          background-image: url(/static/images/common/icon-footer-mine.png);
        }
      }
      p {
        font-size: 22px;
        color: #666666;
        line-height: normal;
        margin-top: 0;
      }
    }
    .router-link-active {
      i{
      }
    }
  }
}
</style>
